import { TextField } from '@mui/material';

interface ReadonlyTextInputProps {
  label: string;
  value: string;
}

export const ReadonlyTextInput = ({ label, value }: ReadonlyTextInputProps) => {
  return (
    <TextField
      type='text'
      label={label}
      variant='outlined'
      fullWidth
      role='textbox'
      value={value}
      disabled
    />
  );
};
